const formatNumbers = (num)=>{
    if (num < 10) return `0${num}`.slice(-2);
    if (num > 999999) return `${(num / 1000000).toFixed(1)}M`;
    if (num > 999) return `${(num / 1000).toFixed(1)}k`;
    return num;
};
const src_formatNumbers = formatNumbers;
export default src_formatNumbers;
